import { Directive, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { startWith, switchMap } from 'rxjs/operators';

import { RegisterPermissionType } from '@assetaccountant/api/models/register-permission-type';
import { AuthorizationService } from '../services/authorization.service';
import { Authorizer } from './authorizer';
import { getRouteChangesWith } from './authorizer.helpers';

@Directive()
export abstract class AuthorizeRegisterBase implements Authorizer, OnChanges {
  abstract registerId?: number;
  private input$ = new BehaviorSubject<{ registerId: number } | null>(null);
  readonly order = 20;

  readonly changes$ = getRouteChangesWith(
    this.router,
    'register',
    register => ({
      registerId: register.id,
    }),
    this.input$,
  );

  readonly isAuthorizedChanges = this.changes$.pipe(
    switchMap(data => {
      if (data) {
        return this.isAuthorizedForRegister(data.registerId).pipe(startWith(false));
      }
      return of(false);
    }),
  );

  constructor(
    private authorizationService: AuthorizationService,
    private router: Router,
  ) {}

  ngOnChanges() {
    this.input$.next(this.registerId ? { registerId: this.registerId } : null);
  }

  protected abstract isAuthorizedForRegister(registerId?: number): Observable<boolean>;

  protected isAuthorizedForPermission(registerId: number, permission: RegisterPermissionType) {
    return this.authorizationService.isRegisterAuthorized(registerId, permission);
  }
}
